






import VueOptions from '@utils/VueOptions'
import Carousel from '@ui/Carousel'

settings =
  name: 'EventHero'

  vue:
    props: ['event']
    components: { Carousel }

    computed:
      heroImages: -> @event.images || []

      carouselOptions: ->
        opts = { height: '380px' }
        opts.perPage = @heroImages.length if @heroImages.length < 3
        opts.perPage ||= 2.50
        opts

export default VueOptions.vue settings
